function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.99989 12.0002C1.99989 6.47799 6.47768 2.0002 11.9999 2.0002C17.5228 2.0002 21.9999 6.47765 21.9999 12.0002C21.9999 17.5227 17.5228 22.0002 11.9999 22.0002C6.47768 22.0002 1.99989 17.5224 1.99989 12.0002ZM20.4999 12.0002C20.4999 7.30606 16.6943 3.5002 11.9999 3.5002C7.30611 3.5002 3.49989 7.30641 3.49989 12.0002C3.49989 16.694 7.30611 20.5002 11.9999 20.5002C16.6943 20.5002 20.4999 16.6943 20.4999 12.0002ZM11.995 7.4543C12.3747 7.4543 12.6885 7.73645 12.7381 8.10253L12.745 8.2043V12.6233C12.745 13.0375 12.4092 13.3733 11.995 13.3733C11.6153 13.3733 11.3015 13.0911 11.2518 12.7251L11.245 12.6233V8.2043C11.245 7.79009 11.5808 7.4543 11.995 7.4543ZM12.755 15.7961C12.755 15.3819 12.4192 15.0461 12.005 15.0461L11.8932 15.0529C11.5271 15.1026 11.245 15.4164 11.245 15.7961C11.245 16.2103 11.5808 16.5461 11.995 16.5461L12.1068 16.5393C12.4728 16.4896 12.755 16.1758 12.755 15.7961Z",
  fill: "#862D2D"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.806744e7.svg";
export { ForwardRef as ReactComponent };